import { FunnelHeaderMilestone, FunnelHeaderStepType } from "pax-ui/components";
import { Product } from "src/app/shared/store/shared/product";
import {
  getPagePath,
  Page,
  START_PAGE,
} from "../../shared/shared-route.constant";

// Quote (Term Life Insurance)
export const startPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  START_PAGE,
);

export const optionalEmailPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_OPTIONAL_EMAIL,
);

export const genderPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_GENDER,
);

export const dateOfBirthPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_DATE_OF_BIRTH,
);

export const smokerPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_SMOKER,
);

export const insuredSumPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_INSURED_SUM,
);

export const insuranceTermPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_INSURANCE_TERM,
);

export const premiumPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_PREMIUM,
);

export const beneficiaryPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_BENEFICIARY,
);

export const personalDetailsPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_PERSONAL_DETAILS,
);

export const occupationsPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_OCCUPATION,
);

export const summaryPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_SUMMARY,
);

export const underwritingBmiPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_UNDERWRITING_BMI,
);

export const underwritingQuestionsPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_UNDERWRITING_QUESTIONS,
);

export const emailPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.QUOTE_EMAIL,
);

// Note: We can't use our existing CustomRoute[] as we would then have a cyclic dependency
// Note: Pay attention to the order of the entries as they are used to display the breadcrumbs for the progress bar
export const quoteFunnelHeaderMilestones: FunnelHeaderMilestone[] = [
  {
    title: $localize`Prämie berechnen`,
    text: $localize`Mit nur wenigen Angaben erfahren Sie Ihre Prämie in wenigen Minuten.`,
    steps: [
      {
        title: $localize`Optionale E-Mail`,
        path: optionalEmailPagePath,
      },
      {
        title: $localize`Geschlecht`,
        path: genderPagePath,
      },
      {
        title: $localize`Geburtsdatum`,
        path: dateOfBirthPagePath,
      },
      {
        title: $localize`Raucher`,
        path: smokerPagePath,
      },
      {
        title: $localize`Versicherte Summe`,
        path: insuredSumPagePath,
      },
      {
        title: $localize`Laufzeit`,
        path: insuranceTermPagePath,
      },
      {
        title: $localize`Prämie`,
        path: premiumPagePath,
      },
    ],
  },
  {
    title: $localize`Antragsdaten erfassen`,
    text: $localize`Prüfen Sie Ihre Eignung für eine Lebensversicherung, indem Sie einen Online-Fragebogen zu Ihrer Gesundheit ausfüllen.`,
    steps: [
      {
        title: $localize`E-Mail`,
        path: emailPagePath,
      },
      {
        title: $localize`BMI`,
        path: underwritingBmiPagePath,
      },
      {
        title: $localize`Leben und Gesundheit`,
        path: underwritingQuestionsPagePath,
        type: FunnelHeaderStepType.DIGITAL_APPLICATION,
      },
      {
        title: $localize`Begünstigung`,
        path: beneficiaryPagePath,
      },
      {
        title: $localize`Persönliche Details`,
        path: personalDetailsPagePath,
      },
      {
        title: $localize`Erwerbstätigkeit`,
        path: occupationsPagePath,
      },
      {
        title: $localize`Zusammenfassung`,
        path: summaryPagePath,
      },
    ],
  },
];
